export default (value) => {
  const date = new Date(value);
  return `${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`
};
